var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SPLIT_READY, SPLIT_READY_WITH_EVALUATIONS, SPLIT_READY_FROM_CACHE, SPLIT_READY_FROM_CACHE_WITH_EVALUATIONS, SPLIT_UPDATE, SPLIT_UPDATE_WITH_EVALUATIONS, SPLIT_TIMEDOUT, SPLIT_DESTROY, ADD_TREATMENTS, } from './constants';
/**
 * Initial default state for Split reducer
 */
var initialState = {
    isReady: false,
    isReadyFromCache: false,
    isTimedout: false,
    hasTimedout: false,
    isDestroyed: false,
    lastUpdate: 0,
    treatments: {},
};
function setReady(state, timestamp) {
    return __assign(__assign({}, state), { isReady: true, isTimedout: false, lastUpdate: timestamp });
}
function setReadyFromCache(state, timestamp) {
    return __assign(__assign({}, state), { isReadyFromCache: true, lastUpdate: timestamp });
}
function setUpdated(state, timestamp) {
    return __assign(__assign({}, state), { lastUpdate: timestamp });
}
/**
 * Copy the given `treatments` for the given `key` to a `result` Split's slice of state. Returns the `result` object.
 */
function assignTreatments(result, key, treatments) {
    result.treatments = __assign({}, result.treatments);
    Object.entries(treatments).forEach(function (_a) {
        var _b, _c;
        var featureFlagName = _a[0], treatment = _a[1];
        if (result.treatments[featureFlagName]) {
            var splitTreatments = result.treatments[featureFlagName];
            if (!splitTreatments[key] || splitTreatments[key].treatment !== treatment.treatment || splitTreatments[key].config !== treatment.config) {
                result.treatments[featureFlagName] = __assign(__assign({}, (result.treatments[featureFlagName])), (_b = {}, _b[key] = treatment, _b));
            }
        }
        else {
            result.treatments[featureFlagName] = (_c = {}, _c[key] = treatment, _c);
        }
    });
    return result;
}
/**
 * Split reducer.
 * It updates the Split's slice of state.
 */
export var splitReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SPLIT_READY:
            return setReady(state, action.payload.timestamp);
        case SPLIT_READY_FROM_CACHE:
            return setReadyFromCache(state, action.payload.timestamp);
        case SPLIT_TIMEDOUT:
            return __assign(__assign({}, state), { isTimedout: true, hasTimedout: true, lastUpdate: action.payload.timestamp });
        case SPLIT_UPDATE:
            return setUpdated(state, action.payload.timestamp);
        case SPLIT_DESTROY:
            return __assign(__assign({}, state), { isDestroyed: true, lastUpdate: action.payload.timestamp });
        case ADD_TREATMENTS: {
            var _a = action.payload, key = _a.key, treatments = _a.treatments;
            var result = __assign({}, state);
            return assignTreatments(result, key, treatments);
        }
        case SPLIT_READY_WITH_EVALUATIONS: {
            var _b = action.payload, key = _b.key, treatments = _b.treatments, timestamp = _b.timestamp;
            var result = setReady(state, timestamp);
            return assignTreatments(result, key, treatments);
        }
        case SPLIT_READY_FROM_CACHE_WITH_EVALUATIONS: {
            var _c = action.payload, key = _c.key, treatments = _c.treatments, timestamp = _c.timestamp;
            var result = setReadyFromCache(state, timestamp);
            return assignTreatments(result, key, treatments);
        }
        case SPLIT_UPDATE_WITH_EVALUATIONS: {
            var _d = action.payload, key = _d.key, treatments = _d.treatments, timestamp = _d.timestamp;
            var result = setUpdated(state, timestamp);
            return assignTreatments(result, key, treatments);
        }
        default:
            return state;
    }
};
